/* eslint-disable no-undef */
import { colors } from 'src/constants';
import { PermissionApiName } from 'src/types';
import { TapTapOperationDashboardColumn } from '../types';
import { quickFilterViewsLabels } from './taptap-filters';
import { taptapStatuses } from './taptap-flow-process';

export const TAPTAP_OPERATION_DASHBOARD_OTHERS_VALUE =
  '__TAPTAP_OPERATION_DASHBOARD_OTHERS__';

/**
 * lightBlue[800]  - SALES / CASHIER DEPARTMENT
 * pink[800]       - ACCOUNTING / ECOMM COORDINATOR
 * amber[800]      - WAREHOUSE DEPARTMENT
 * teal[800]       - TECHNICAL DEPARTMENT
 */
export const taptapOperationDashboardColumns: TapTapOperationDashboardColumn[] = [
  {
    key: 'sales_transfer_request',
    label: taptapStatuses.SALES_TRANSFER_REQUEST,
    value: taptapStatuses.PENDING_SALES_TRANSFER,
    bgColor: colors.amber[800],
    visible: true
  },

  //===== CASHIER COLUMN =======
  {
    key: 'for_payment',
    label: taptapStatuses.FOR_PAYMENT,
    value: taptapStatuses.FOR_PAYMENT,
    bgColor: colors.lightBlue[800],
    visible: true
  },

  //VIEWABLE ALSO BY ECOMM COORDINATOR
  {
    key: 'online_fund_transfer',
    label: taptapStatuses.ONLINE_FUND_TRANSFER,
    value: taptapStatuses.ONLINE_FUND_TRANSFER,
    bgColor: colors.pink[800],
    visible: true
  },
  {
    key: 'payment_collection',
    label: taptapStatuses.PAYMENT_COLLECTION,
    value: taptapStatuses.PAYMENT_COLLECTION,
    bgColor: colors.pink[800],
    visible: true
  },

  //======= WAREHOUSE DEPARTMENT ========

  {
    key: 'reserved',
    label: taptapStatuses.RESERVED,
    value: taptapStatuses.RESERVED,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'done_payment',
    label: taptapStatuses.DONE_PAYMENT,
    value: taptapStatuses.DONE_PAYMENT,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'preparing_items',
    label: taptapStatuses.PREPARING_ITEMS,
    value: taptapStatuses.PREPARING_ITEMS,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'releasing',
    label: taptapStatuses.RELEASING,
    value: taptapStatuses.RELEASING,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'for_packing',
    label: taptapStatuses.FOR_PACKING,
    value: taptapStatuses.FOR_PACKING,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'ready_for_pickup',
    label: taptapStatuses.READY_FOR_PICKUP,
    value: taptapStatuses.READY_FOR_PICKUP,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'ready_for_delivery',
    label: taptapStatuses.READY_FOR_DELIVERY,
    value: taptapStatuses.READY_FOR_DELIVERY,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'rma_changed_item',
    label: taptapStatuses.RMA_CHANGED_ITEM,
    value: taptapStatuses.RMA_CHANGED_ITEM,
    bgColor: colors.amber[800],
    visible: true
  },

  //=====TECHNICAL DEPARTMENT======
  {
    key: 'on_queue',
    label: taptapStatuses.ON_QUEUE,
    value: taptapStatuses.ON_QUEUE,
    bgColor: colors.teal[800],
    visible: true
  },
  {
    key: 'testing',
    label: taptapStatuses.TESTING,
    value: taptapStatuses.TESTING,
    bgColor: colors.teal[800],
    visible: true
  },
  {
    key: 'building',
    label: taptapStatuses.BUILDING,
    value: taptapStatuses.BUILDING,
    bgColor: colors.teal[800],
    visible: true
  },

  //====== SUPERIOR OR BRANCH OIC ======

  {
    key: 'pending_sales_transfer',
    label: taptapStatuses.PENDING_SALES_TRANSFER,
    value: taptapStatuses.PENDING_SALES_TRANSFER,
    bgColor: colors.amber[800],
    visible: true
  },
  {
    key: 'sales_transfer_on_going',
    label: taptapStatuses.SALES_TRANSFER_ON_GOING,
    value: taptapStatuses.SALES_TRANSFER_ON_GOING,
    bgColor: colors.amber[800],
    visible: true
  },
  {
    key: 'in_house_delivery_for_sales_transfer',
    label: taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    value: taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    bgColor: colors.amber[800],
    visible: true
  },
  {
    key: 'sales_transfer_receiving',
    label: taptapStatuses.SALES_TRANSFER_RECEIVING,
    value: taptapStatuses.SALES_TRANSFER_RECEIVING,
    bgColor: colors.amber[800],
    visible: true
  },
  {
    key: 'sales_transfer_releasing',
    label: taptapStatuses.SALES_TRANSFER_RELEASING,
    value: taptapStatuses.SALES_TRANSFER_RELEASING,
    bgColor: colors.amber[800],
    visible: true
  },
  {
    key: 'sales_transfer_dispatching',
    label: taptapStatuses.SALES_TRANSFER_DISPATCHING,
    value: taptapStatuses.SALES_TRANSFER_DISPATCHING,
    bgColor: colors.amber[800],
    visible: true
  },
  {
    key: 'sales_transfer_branch_received',
    label: taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
    value: taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
    bgColor: colors.amber[800],
    visible: true
  },

  {
    key: 'completed',
    label: taptapStatuses.COMPLETED,
    value: taptapStatuses.COMPLETED,
    bgColor: colors.green[800],
    visible: true
  },

  {
    key: 'refund',
    label: taptapStatuses.REFUND,
    value: taptapStatuses.REFUND,
    bgColor: colors.pink[800],
    visible: true
  },

  {
    key: 'hold',
    label: taptapStatuses.HOLD,
    value: taptapStatuses.HOLD,
    bgColor: colors.grey[700],
    visible: true
  },
  {
    key: 'cancelled',
    label: taptapStatuses.CANCELLED,
    value: taptapStatuses.CANCELLED,
    bgColor: colors.red[800],
    visible: true
  },
  {
    key: 'others',
    label: 'OTHERS',
    value: TAPTAP_OPERATION_DASHBOARD_OTHERS_VALUE,
    bgColor: colors.grey[800],
    visible: true
  },
  {
    key: 'sales_transfer_complete',
    label: taptapStatuses.SALES_TRANSFER_COMPLETE,
    value: taptapStatuses.SALES_TRANSFER_COMPLETE,
    bgColor: colors.green[800],
    visible: true
  }
];

const allOperationDashboardStatusValues = taptapOperationDashboardColumns
  .map((column) => column.value)
  .filter((status) => status !== TAPTAP_OPERATION_DASHBOARD_OTHERS_VALUE);
const uniqueOperationDashboardStatusValues = Array.from(
  new Set(allOperationDashboardStatusValues)
);

const salesTransferOperationDashboardStatusValues = [
  taptapStatuses.PENDING_SALES_TRANSFER,
  taptapStatuses.SALES_TRANSFER_REQUEST,
  taptapStatuses.SALES_TRANSFER_ON_GOING,
  taptapStatuses.SALES_TRANSFER_COMPLETE,
  taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
  taptapStatuses.SALES_TRANSFER_RECEIVING,
  taptapStatuses.SALES_TRANSFER_RELEASING
];

const salesOperationDashboardStatusValues = [
  ...uniqueOperationDashboardStatusValues.filter(
    (status) => !salesTransferOperationDashboardStatusValues.includes(status)
  ),
  taptapStatuses.SALES_TRANSFER_REQUEST
];

const adminOperationDashboardPermissions: PermissionApiName[] = [
  'can_view_all_taptap_dashboard',
  'read_only_taptap_admin_dashboard'
];

const salesTransferRequestColumnPermissions: PermissionApiName[] = [
  'can_view_taptap_sales_dashboard',
  'can_view_taptap_warehouse_dashboard',
  ...adminOperationDashboardPermissions
];

const salesTransferOnGoingColumnPermissions: PermissionApiName[] = [
  'can_view_taptap_warehouse_dashboard',
  ...adminOperationDashboardPermissions
];

const salesTransferCompleteColumnPermissions: PermissionApiName[] = [
  'can_view_taptap_warehouse_dashboard',
  ...adminOperationDashboardPermissions
];

export const taptapOperationDashboardColumnStatusesByPermission: Partial<Record<
  PermissionApiName,
  string[]
>> = {
  can_view_taptap_sales_dashboard: salesOperationDashboardStatusValues,
  can_view_taptap_cashier_dashboard: [
    taptapStatuses.FOR_PAYMENT,
    taptapStatuses.REFUND,
    taptapStatuses.ONLINE_FUND_TRANSFER,
    taptapStatuses.PAYMENT_COLLECTION,
    taptapStatuses.RESERVED,
    taptapStatuses.SALES_TRANSFER_RELEASING
  ],
  can_view_taptap_accounting_dashboard: [
    taptapStatuses.ONLINE_FUND_TRANSFER,
    taptapStatuses.PAYMENT_COLLECTION,
    taptapStatuses.RELEASING,
    taptapStatuses.RESERVED
  ],
  can_view_taptap_warehouse_dashboard: [
    taptapStatuses.RMA_CHANGED_ITEM,
    taptapStatuses.DONE_PAYMENT,
    taptapStatuses.PREPARING_ITEMS,
    taptapStatuses.RELEASING,
    taptapStatuses.RESERVED,
    taptapStatuses.FOR_PACKING,
    taptapStatuses.READY_FOR_PICKUP,
    taptapStatuses.READY_FOR_DELIVERY,
    taptapStatuses.PENDING_SALES_TRANSFER,
    taptapStatuses.SALES_TRANSFER_REQUEST,
    taptapStatuses.SALES_TRANSFER_ON_GOING,
    taptapStatuses.SALES_TRANSFER_COMPLETE,
    taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    taptapStatuses.SALES_TRANSFER_RECEIVING,
    taptapStatuses.SALES_TRANSFER_RELEASING,
    taptapStatuses.SALES_TRANSFER_DISPATCHING,
    taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED
  ],
  can_view_taptap_build_dashboard: [
    taptapStatuses.READY_FOR_PICKUP,
    taptapStatuses.ON_QUEUE,
    taptapStatuses.BUILDING,
    taptapStatuses.TESTING
  ],
  can_view_after_care_dashboard: [taptapStatuses.COMPLETED],
  can_view_all_taptap_dashboard: uniqueOperationDashboardStatusValues,
  read_only_taptap_admin_dashboard: uniqueOperationDashboardStatusValues
};

export const taptapOperationDashboardColumnStatusesByQuickView: Record<
  string,
  string[]
> = {
  [quickFilterViewsLabels.ALL]: uniqueOperationDashboardStatusValues,
  [quickFilterViewsLabels.SALES_VIEW]: salesOperationDashboardStatusValues,
  [quickFilterViewsLabels.CASHIER]: [
    taptapStatuses.FOR_PAYMENT,
    taptapStatuses.REFUND,
    taptapStatuses.ONLINE_FUND_TRANSFER,
    taptapStatuses.PAYMENT_COLLECTION,
    taptapStatuses.RESERVED,
    taptapStatuses.SALES_TRANSFER_RELEASING,
    taptapStatuses.HOLD,
    taptapStatuses.CANCELLED
  ],
  [quickFilterViewsLabels.PAYMENT_VERIFICATION]: [
    taptapStatuses.ONLINE_FUND_TRANSFER,
    taptapStatuses.PAYMENT_COLLECTION,
    taptapStatuses.RESERVED,
    taptapStatuses.HOLD,
    taptapStatuses.CANCELLED
  ],
  [quickFilterViewsLabels.RELEASING]: [
    taptapStatuses.RMA_CHANGED_ITEM,
    taptapStatuses.DONE_PAYMENT,
    taptapStatuses.PREPARING_ITEMS,
    taptapStatuses.RELEASING,
    taptapStatuses.RESERVED,
    taptapStatuses.FOR_PACKING,
    taptapStatuses.READY_FOR_PICKUP,
    taptapStatuses.READY_FOR_DELIVERY,
    taptapStatuses.SALES_TRANSFER_ON_GOING,
    taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    taptapStatuses.SALES_TRANSFER_RECEIVING,
    taptapStatuses.SALES_TRANSFER_RELEASING,
    taptapStatuses.SALES_TRANSFER_DISPATCHING,
    taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
    taptapStatuses.HOLD,
    taptapStatuses.CANCELLED
  ],
  [quickFilterViewsLabels.SALES_TRANSFER]: [
    ...salesTransferOperationDashboardStatusValues
  ],
  [quickFilterViewsLabels.FOR_BUILD]: [
    taptapStatuses.READY_FOR_PICKUP,
    taptapStatuses.ON_QUEUE,
    taptapStatuses.BUILDING,
    taptapStatuses.TESTING,
    taptapStatuses.HOLD,
    taptapStatuses.CANCELLED
  ],
  [quickFilterViewsLabels.AFTER_CARE_QA]: [taptapStatuses.COMPLETED]
};

export const getTaptapOperationDashboardAccessibleColumns = (
  columns: TapTapOperationDashboardColumn[],
  userPermissions: PermissionApiName[],
  quickViewLabel?: string
) => {
  const allowedStatuses = userPermissions.flatMap(
    (permission) =>
      taptapOperationDashboardColumnStatusesByPermission[permission] || []
  );
  const allowedStatusSet = new Set(allowedStatuses);
  const canViewOthersColumn = userPermissions.some((permission) =>
    adminOperationDashboardPermissions.includes(permission)
  );
  const quickViewStatuses = quickViewLabel
    ? taptapOperationDashboardColumnStatusesByQuickView[quickViewLabel]
    : undefined;
  const quickViewStatusSet = quickViewStatuses
    ? new Set(quickViewStatuses)
    : undefined;

  return columns.filter((column) => {
    const isSalesTransferRequestColumn =
      column.key === 'sales_transfer_request';
    const isSalesTransferOnGoingColumn =
      column.key === 'sales_transfer_on_going';
    const isSalesTransferCompleteColumn =
      column.key === 'sales_transfer_complete';
    const canViewSalesTransferRequestColumn =
      isSalesTransferRequestColumn &&
      userPermissions.some((permission) =>
        salesTransferRequestColumnPermissions.includes(permission)
      );
    const canViewSalesTransferOnGoingColumn =
      isSalesTransferOnGoingColumn &&
      userPermissions.some((permission) =>
        salesTransferOnGoingColumnPermissions.includes(permission)
      );
    const canViewSalesTransferCompleteColumn =
      isSalesTransferCompleteColumn &&
      userPermissions.some((permission) =>
        salesTransferCompleteColumnPermissions.includes(permission)
      );
    const isAllowedByPermission =
      allowedStatusSet.has(column.value) ||
      canViewSalesTransferRequestColumn ||
      canViewSalesTransferOnGoingColumn ||
      canViewSalesTransferCompleteColumn ||
      (canViewOthersColumn &&
        column.value === TAPTAP_OPERATION_DASHBOARD_OTHERS_VALUE);
    const isAllowedByQuickView =
      !quickViewStatusSet ||
      quickViewStatusSet.has(column.value) ||
      (isSalesTransferRequestColumn &&
        quickViewStatusSet.has(taptapStatuses.SALES_TRANSFER_REQUEST)) ||
      column.value === TAPTAP_OPERATION_DASHBOARD_OTHERS_VALUE;

    return isAllowedByPermission && isAllowedByQuickView;
  });
};
